<div class="customscroll bodywrp">
    <div class="cc1">
        <div></div>
        <span multilang class="cc2">{{title}}</span>
        <button mat-dialog-close class="closebtn">
            <mat-icon class="closebtnico">close</mat-icon>
        </button>
    </div>

    <div class="globalbwert">
        <div class="bwrttop" *ngIf="overall.length > 0">
            <span multilang>GESAMTBEWERTUNG</span>
            <div class="cc3">
                <div class="cc4">
                    <ng-container *ngFor="let bw of overall">
                        <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    </ng-container>
                </div>
                <div class="cc5">
                    {{data.rating?.overall * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        <div class="bwrttop" *ngIf="food.length > 0">
            <span multilang>GASTRONOMIE</span>
            <div class="cc3">
                <div class="cc4">
                    <ng-container *ngFor="let bw of food">
                        <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    </ng-container>
                </div>
                <div class="cc5">
                    {{data.rating?.food * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        <div class="bwrttop" *ngIf="hotel.length > 0">
            <span multilang>HOTEL</span>
            <div class="cc3">
                <div class="cc4">
                    <ng-container *ngFor="let bw of hotel">
                        <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    </ng-container>
                </div>
                <div class="cc5">
                    {{data.rating?.hotel * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        <div class="bwrttop" *ngIf="leisure.length > 0">
            <span multilang>SPORT UND UNTERH.</span>
            <div class="cc3">
                <div class="cc4">
                    <ng-container *ngFor="let bw of leisure">
                        <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    </ng-container>
                </div>
                <div class="cc5">
                    {{data.rating?.leisure * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        <div class="bwrttop" *ngIf="location.length > 0">
            <span multilang>LAGE</span>
            <div class="cc3">
                <div class="cc4">
                    <ng-container *ngFor="let bw of location">
                        <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    </ng-container>
                </div>
                <div class="cc5">
                    {{data.rating?.location * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        <div class="bwrttop" *ngIf="room.length > 0">
            <span multilang>ZIMMER</span>
            <div class="cc3">
                <div class="cc4">
                    <ng-container *ngFor="let bw of room">
                        <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    </ng-container>
                </div>
                <div class="cc5">
                    {{data.rating?.room * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        <div class="bwrttop" *ngIf="service.length > 0">
            <span multilang>SERVICE</span>
            <div class="cc3">
                <div class="cc4">
                    <ng-container *ngFor="let bw of service">
                        <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    </ng-container>
                </div>
                <div class="cc5">
                    {{data.rating?.service * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
    </div>



    <div *ngFor="let review of datas?.hotelReviewList">
        <div class="cc6">
            <div class="cc7">
                <!--Title of review-->
                <span multilang class="cc8">
                    "{{review?.title}}"
                </span>

                <div>
                    <mat-icon class="cc9">account_circle</mat-icon>
                </div>

                <!--Autor review-->
                <span multilang class="cc10">
                    {{review.author ? review.author : 'Anonym'}}
                    {{review.age ? ' (' + review.age + ')' : ''}}
                </span>

                <!--Sub Autor text-->
                <span multilang style="font-size: .9rem;">
                    Verreist als {{review.travelCompaniontext}} - {{review.travelDate | date:'MMM yyyy'}}
                </span>
            </div>




            <div class="perswrp" *ngIf="review?.overall?.length > 0">
                <div class="bwrttop">
                    <span multilang>GESAMTBEWERTUNG</span>
                    <div class="cc3">
                        <div class="cc4">
                            <ng-container *ngFor="let bw of review.overall">
                                <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            </ng-container>
                        </div>
                        <div class="cc5">
                            {{review.rating?.overall * 6 / 100 | number :'1.1-1'}}
                        </div>
                    </div>
                </div>
                <span multilang class="cc11">{{review.text}}</span>
            </div>

            <div class="perswrp" *ngIf="review?.food?.length > 0">
                <div class="bwrttop">
                    <span multilang>GASTRONOMIE</span>
                    <div class="cc3">
                        <div class="cc4">
                            <ng-container *ngFor="let bw of review.food">
                                <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            </ng-container>
                        </div>
                        <div class="cc5">
                            {{review.rating?.food * 6 / 100 | number :'1.1-1'}}
                        </div>
                    </div>
                </div>
                <span multilang class="cc11">{{review.textFood}}</span>
            </div>
            <div class="perswrp" *ngIf="review?.hotel?.length > 0">
                <div class="bwrttop">
                    <span multilang>HOTEL</span>
                    <div class="cc3">
                        <div class="cc4">
                            <ng-container *ngFor="let bw of review.hotel">
                                <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            </ng-container>
                        </div>
                        <div class="cc5">
                            {{review.rating?.hotel * 6 / 100 | number :'1.1-1'}}
                        </div>
                    </div>
                </div>
                <span multilang class="cc11">{{review.textHotel}}</span>
            </div>
            <div class="perswrp" *ngIf="review?.leisure?.length > 0">
                <div class="bwrttop">
                    <span multilang>SPORT UND UNTERH.</span>
                    <div class="cc3">
                        <div class="cc4">
                            <ng-container *ngFor="let bw of review.leisure">
                                <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            </ng-container>
                        </div>
                        <div class="cc5">
                            {{review.rating?.leisure * 6 / 100 | number :'1.1-1'}}
                        </div>
                    </div>
                </div>
                <span multilang class="cc11">{{review.textSports}}</span>
            </div>
            <div class="perswrp" *ngIf="review?.location?.length > 0">
                <div class="bwrttop">
                    <span multilang>LAGE</span>
                    <div class="cc3">
                        <div class="cc4">
                            <ng-container *ngFor="let bw of review.location">
                                <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            </ng-container>
                        </div>
                        <div class="cc5">
                            {{review.rating?.location * 6 / 100 | number :'1.1-1'}}
                        </div>
                    </div>
                </div>
                <span multilang class="cc11">{{review.textLocation}}</span>
            </div>
            <div class="perswrp" *ngIf="review?.room?.length > 0">
                <div class="bwrttop">
                    <span multilang>ZIMMER</span>
                    <div class="cc3">
                        <div class="cc4">
                            <ng-container *ngFor="let bw of review.room">
                                <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            </ng-container>
                        </div>
                        <div class="cc5">
                            {{review.rating?.room * 6 / 100 | number :'1.1-1'}}
                        </div>
                    </div>
                </div>
                <span multilang class="cc11">{{review.textRoom}}</span>
            </div>
            <div class="perswrp" *ngIf="review?.service?.length > 0">
                <div class="bwrttop">
                    <span multilang>SERVICE</span>
                    <div class="cc3">
                        <div class="cc4">
                            <ng-container *ngFor="let bw of review.service">
                                <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            </ng-container>
                        </div>
                        <div class="cc5">
                            {{review.rating?.service * 6 / 100 | number :'1.1-1'}}
                        </div>
                    </div>
                </div>
                <span multilang class="cc11">{{review.textService}}</span>
            </div>
        </div>
    </div>

    <div class="cc12">
        <button class="cc13" mat-dialog-close>OK</button>
    </div>
</div>